import { injectable } from 'inversify';
import type { FormField as FormFieldInterface } from '@shared/common/form/domain/form/field/base.form-field';

export type FormValidationResult = {
  valid: boolean;
};

@injectable()
export class FormValidationService {
  public async validateField(formField: FormFieldInterface<unknown>): Promise<FormValidationResult> {
    const errors: string[] = [];
    for (const rule of formField.rules ?? []) {
      const result = await rule(formField.value as never);
      if (result !== true) {
        errors.push(result);
      }
    }

    formField.errorMessages = errors.length ? errors : undefined;

    return { valid: errors.length === 0 };
  }

  public async validateForm(fields: Record<string, FormFieldInterface<unknown>>): Promise<FormValidationResult> {
    let isValid = true;

    for (const field in fields) {
      if (!Object.prototype.hasOwnProperty.call(fields, field)) {
        continue;
      }

      const formField = fields[field];
      if (formField === undefined) {
        continue;
      }

      const result = await this.validateField(formField);
      if (!result.valid) {
        isValid = false;
      }
    }

    return { valid: isValid };
  }
}
